<template>
  <div style="margin-bottom: 10px;">
    <div class="dianzan">
      <div class="zan-click" :class="[isLike ? 'actived':'']" @click="like">
        <jr-icon
          name="dianzan"
          class="small-icon"
          :class="[isLike ? 'icon-actived':'icon-default']"
        ></jr-icon>
      </div>

      <div style="position: relative;">
        <div class="san"></div>
        <div class="zan-num-box">
          <div class="zan">
            <jr-icon name="dianzan" class="small-icon icon-default"></jr-icon>
            <span>{{likeNum}}赞</span>
          </div>
          <div class="readBtn">
            <el-popover
              placement="right"
              width="310"
              trigger="click">
              <el-table :data="readUserList"
                        height="350"
                        fit
                        border>
                <el-table-column width="150" property="USER_NAME_" label="姓名"></el-table-column>
                <el-table-column width="150" property="READ_TIME_" label="时间"></el-table-column>
              </el-table>
              <span @click="showReadList" slot="reference" class="isread">已阅({{readNum}})</span>
            </el-popover>

          </div>
          <p>{{likeUsers}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mixin} from './index.js'
export default {
  name: 'read-like',
  mixins: [mixin]
}
</script>

<style scoped lang="scss">
  .isread {
    color: #7787b8;
    cursor: pointer;
  }
  .san{
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent transparent #f6f6f6;
    left: 15px;
    /* bottom: 0px; */
    top: -20px;
    position: absolute;
  }

  .zan-num-box {
    /*width: 100%;*/
  // height: 50px;
    padding: 5px 10px;
    background: #f6f6f6;
    color: #999;
  .icon {
    vertical-align: middle;
    font-size: 24px;
  }
  & > span {
      vertical-align: middle;
    }
  }

  .zan-num-box p {
    color: #b4b4b4;
  }

  .readBtn{
    position: absolute;
    right: 10px;
    top :5px;
  }

  .zan-click {
    cursor: pointer;
    text-align: center;
    width: 50px;
    height: 50px;
    margin: 10px auto;
    border-radius: 50%;
    border: 1px solid #eee;
    background: #efefef;
    line-height: 50px;
    color: #aaa;
  }

  .zan-click.actived {
    background: #ffeaca;
    border:none !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/form/read-like/index.vue